import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query';
import { useState } from 'react';

import { schedulesApi, type TimelineParams } from '../api/schedules-api';

import { scheduleKeys } from './schedule-keys';

/** Decision 25: the upcoming view covers four weeks, well inside the endpoint's 92-day cap. */
export const UPCOMING_DAYS = 28;

const DAY = 24 * 60 * 60 * 1000;
const MINUTE = 60 * 1000;

/** From now (to the minute, so the key is stable while the page is open) for four weeks. */
export function upcomingWindow(now = new Date()): { from: string; to: string } {
  const from = Math.floor(now.getTime() / MINUTE) * MINUTE;
  return {
    from: new Date(from).toISOString(),
    to: new Date(from + UPCOMING_DAYS * DAY).toISOString(),
  };
}

export function scheduleTimelineQueryOptions(params: TimelineParams) {
  return queryOptions({
    queryKey: scheduleKeys.timeline(params),
    queryFn: () => schedulesApi.timeline(params),
    placeholderData: keepPreviousData,
  });
}

export interface TimelineScope {
  storeId?: string | null;
  /** One schedule's runs, filtered by the backend before its caps; no one-shot dates. */
  scheduleId?: string | null;
}

/** The next four weeks of predicted runs and one-shot dates, for one store or one schedule. */
export function useScheduleTimeline({ storeId, scheduleId }: TimelineScope = {}) {
  const [range] = useState(upcomingWindow);
  return useQuery(
    scheduleTimelineQueryOptions({
      ...range,
      ...(storeId ? { storeId } : {}),
      ...(scheduleId ? { scheduleId } : {}),
    }),
  );
}
